module.exports = __webpack_public_path__ + "img/IMG_1492.8a248a97.jpg";